import moment from 'moment';

export default class DocutaxRequestSearchResult {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  officeId;

  /**
   * @type {string}
   */
  officeEFIN;

  /**
   * @type {number}
   */
  assignedPreparerId;

  /**
   * @type {string}
   */
  assignedPreparerName;

  /**
   * @type {number}
   */
  clientId;

  /**
   * @type {string}
   */
  clientName;

  /**
   * @type {string}
   */
  clientCellPhone;

  /**
   * @type {string}
   */
  clientEmailAddress;

  /**
   * @type {string}
   */
  message = '';

  /**
   * @type {boolean}
   */
  hasResponded = false;

  /**
   * @type {Moment}
   */
  createdDate;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.officeEFIN != null) {
        this.officeEFIN = opts.officeEFIN;
      }
      if (opts.assignedPreparerId != null) {
        this.assignedPreparerId = opts.assignedPreparerId;
      }
      if (opts.assignedPreparerName != null) {
        this.assignedPreparerName = opts.assignedPreparerName;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.clientName != null) {
        this.clientName = opts.clientName;
      }
      if (opts.clientCellPhone != null) {
        this.clientCellPhone = opts.clientCellPhone;
      }
      if (opts.clientEmailAddress != null) {
        this.clientEmailAddress = opts.clientEmailAddress;
      }
      if (opts.message != null) {
        this.message = opts.message;
      }
      if (opts.hasResponded != null) {
        this.hasResponded = opts.hasResponded;
      }
      if (opts.createdDate != null) {
        if (moment.isMoment(opts.createdDate)) {
          this.createdDate = opts.createdDate;
        } else {
          this.createdDate = moment(opts.createdDate.date);
        }
      }
    }
  }
}
